import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../texts/header_text.png';
import './HeaderText.css';

export function HeaderText() {
  return (
    <SharedHeaderText
      className="new-delivery-header-text"
      src={headerTextImg}
      alt="Новая доставка!"
    />
  );
}
